import {createRoot, hydrateRoot} from 'react-dom/client';
import LetsTalk from '../pages/LetsTalk/LetsTalk'
import "../index.css";
import "../pages/LetsTalk/LetsTalk.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<LetsTalk {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <LetsTalk {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).LetsTalkVC = {mount, hydrate, unmount}